import moment from 'moment-jalaali';
import {ADD_ERROR, REMOVE_ERROR} from '../constants/error';


function data(state = [], action) {
  switch (action.type) {
    case ADD_ERROR:
      const id = `${(moment() - moment().startOf('day'))}-${Math.floor(Math.random() * 1e8)}`;
      return [...state, {id, ...action.payload}];
    case REMOVE_ERROR:
      return state.filter(error => error.id !== action.payload.id);

    default:
      return state;
  }
}

export default data;
